import { isAxiosError } from 'axios';
import { get, isArray } from 'lodash';

type ErrorMessages = {
  [key: string]: {
    [key: string]: string;
    default: string;
  };
};

const getMessage = (error: unknown, field: string, messages: ErrorMessages) => {
  if (!isAxiosError(error)) return '';

  const apiMessages = get(error.response?.data, field);

  if (!isArray(apiMessages)) return '';

  return get(messages[field], apiMessages[0], messages[field].default);
};

const getSaveErrorMessage = (
  error: unknown,
  status: 'create' | 'edit',
  messages: ErrorMessages,
): string => {
  const humanizedType = status === 'create' ? 'criar' : 'atualizar';
  let message = `Falha ao ${humanizedType} o registro.`;

  Object.keys(messages).forEach((key) => {
    const fieldMessage = getMessage(error, key, messages);
    if (fieldMessage) {
      message += ` ${fieldMessage}`;
    }
  });

  return message;
};

export default getSaveErrorMessage;
